import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const fetchSavedOrderReturns = async (facilityIds, pageNumber = 1, pageSize = 10) => {
    const params = { pageNumber, pageSize };
    const ids = Array.isArray(facilityIds) ? facilityIds : facilityIds ? [facilityIds] : [];
    if (ids.length > 0) {
        params.facilityIds = ids;
    }

    const response = await SrxApi.get('/orderReturns/saved-returns', {
        params,
        paramsSerializer: (p) =>
            Object.entries(p)
                .flatMap(([key, value]) =>
                    Array.isArray(value)
                        ? value.map((v) => `${key}=${encodeURIComponent(v)}`)
                        : `${key}=${encodeURIComponent(value)}`
                )
                .join('&'),
    });
    return response?.data;
};

const useSavedOrderReturns = (facilityIds, pageNumber = 1, pageSize = 10) => {
    const {
        data: savedOrderReturnsRaw = null,
        isFetching: isSavedOrderReturnsLoading,
        refetch: refetchSavedOrderReturns,
    } = useQuery(
        ['savedOrderReturns', facilityIds, pageNumber, pageSize],
        () => fetchSavedOrderReturns(facilityIds, pageNumber, pageSize),
        {
            staleTime: 0,
            onError: (error) => {
                const msg = error?.response?.data?.message || error?.message || 'Failed to load saved order returns';
                toast.error(msg);
            },
        }
    );

    return {
        savedOrderReturnsRaw,
        isSavedOrderReturnsLoading,
        refetchSavedOrderReturns,
    };
};

export default useSavedOrderReturns;
